import debounce from 'lodash/debounce';
import { hasAccess } from '~/services/permissions/permissions';

let timeoutEnter;
const sidebarTransitionDuration = 300;

function expandSidebar_NewUI() {
    setTimeout(function() {
        $('#sidebar').find('.nav > li .icon-arrow-down-bold').css('display', 'inline-block');

        const currentPageLink = $('.sidebar-open-squeeze #sidebar .nav > li:not(.mobile)').find('a[href="' + window.location.pathname + '"]')
        if(currentPageLink.length > 0) {
            const parentMenu = (currentPageLink.parents('li.has-sub'));
            if(parentMenu.length > 0) {
                parentMenu.find('a:first').trigger('click');
            }
        }

    }, sidebarTransitionDuration);
}

function showHiddenIcons() {
    const sidebar = $('#sidebar .nav > li');
    if (isWindowConstrainedToMobileThreshold()) {
        sidebar.find('a > img')
            .css('display', 'inline');
        sidebar.find('a > i')
            .css('display', 'table');
        sidebar.find('form.navbar-form')
            .css('display', 'inline-block');

        let secondaryColor;    
        if (window.localStorage.getItem('userInterfaceSecondaryColor')) {
            secondaryColor = window.localStorage.getItem('userInterfaceSecondaryColor');
        } else {
            secondaryColor = '#0E82EE';
        }

        $('.sidebar .nav > li.active > a').css({'box-shadow':'2px 0 0 ' + secondaryColor + ' inset', 'border-right':'1px solid #51585e', 'background':'rgba(175, 200, 219, 0.16)'});
    }
}

function shrinkSidebar_NewUI() {
    $('#sidebar').find('.nav > li .icon-arrow-down-bold').css('display', 'none');
}

function closeSubMenus_NewUI() {
    const sidebar = $('#sidebar');
    const expanded = sidebar.find('.has-sub.expand');
    expanded.find('a:first').blur();
    expanded.removeClass('expand');

    sidebar.find(' .sub-menu').css('display', 'none');
    sidebar.find('.has-sub').removeClass('sidebar-menu-caret-rotate');
}

function debounceEnter_NewUI() {
    if (hasAccess('NewUI')){
        timeoutEnter = setTimeout(() => {
            var sidebarIsOpen = $('body.sidebar-open-squeeze').length;

            if (!sidebarIsOpen && document.hasFocus()) {
                $('body').addClass('sidebar-open');
                expandSidebar_NewUI();
            }
        }, 300);
    }
}

$('#sidebar').find('.nav').on('mouseenter', debounceEnter_NewUI);

$('#sidebar').find('.nav').on('mouseleave', function() {
    if (hasAccess('NewUI')) {
        clearTimeout(timeoutEnter);

        var sidebarIsOpen = $('body.sidebar-open-squeeze').length;

        if (!sidebarIsOpen && document.hasFocus()) {
            $('body').removeClass('sidebar-open');
            shrinkSidebar_NewUI();
            closeSubMenus_NewUI();
        }
    }
});

$('.js-sidebar-toggle').on('click', function(){
    if(hasAccess('NewUI')){
        $('body').toggleClass('sidebar-open-squeeze');

        var sidebarIsOpen = $('body.sidebar-open-squeeze').length;

        if (sidebarIsOpen) {
            showHiddenIcons();
            expandSidebar_NewUI();
            localStorage.setItem('sidebar', 'open');
        } else {
            shrinkSidebar_NewUI();
            closeSubMenus_NewUI();
            localStorage.setItem('sidebar', 'closed');
        }
    } else {
        if (!isWindowConstrainedToMobileThreshold()) {
            $('body').toggleClass('sidebar-open');

            if ($('body').hasClass('sidebar-open')) {
                localStorage.setItem('sidebar', 'open');
            } else {
                localStorage.removeItem('sidebar');
            }
        } else {
            $('body').toggleClass('sidebar-open');

            if (localStorage.getItem('sidebar')) {
                localStorage.removeItem('sidebar');
            }
        }
    }
});

$('.sidebar .nav > li.has-sub').on('click', function() {
    if (hasAccess('NewUI')) {
        if ($(this).hasClass('expand')) {
            $(this).find('a:first').blur();
        }
    }
});
